import { FelaCSS, FelaCSSWithCustomSelectors, colors } from '@bridebook/ui';

interface IStyles {
  awardListWrap: FelaCSS;
  awardsTitle: FelaCSS;
  awardsDescription: FelaCSS;
  awardListItem: (mobileOrder: number) => FelaCSSWithCustomSelectors;
  accordionWrapper: FelaCSS;
}

const styles = (): IStyles => ({
  awardListWrap: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },

  awardListItem: (mobileOrder: number): FelaCSS => ({
    flexShrink: 0,
    width: '50%',
    marginBottom: 8,

    maxWidthMobile: {
      width: '100%',
      order: mobileOrder,
    },

    ':last-of-type': {
      marginBottom: 0,
      width: '100%',
      marginLeft: 0,
    },
  }),
  awardsTitle: {
    fontDefaultSemiBold: 28,
    marginBottom: 2,
    maxWidthMobile: {
      fontDefaultSemiBold: 20,
    },
  },
  awardsDescription: {
    fontDefault: 14,
  },
  accordionWrapper: {
    borderBottom: `1px solid ${colors.space15}`,
    paddingVertical: 5,
  },
});

export default styles;
